import { autorun } from 'mobx';
import { getStore } from './stores';

const baseClass = 'ItineraryOverlay';
const classes = {
	dialogBackground: 'Dialog',
	dialogOverlay: 'Dialog-overlay',
	dialogWrapper: 'Dialog-wrapper',
	dialogCloseButton: 'Dialog-closebutton',
	dialogContent: 'Dialog-content',
	open: `${baseClass}-open`,
};
const selectors = {
	overlay: `.${baseClass}`,
	dialogWrapper: `.${classes.dialogWrapper}`,
};

const open = ($overlay, delay = 100) => {
	$('body').css('overflow', 'hidden');
	$overlay.attr('aria-hidden', 'false');
	window.setTimeout(() => {
		//small timeout to combat pop-in
		$overlay.addClass(classes.open);
	}, delay);
};

const close = ($overlay, delay = 500) => {
	$('body').css('overflow', '');
	$overlay.removeClass(classes.open);
	window.setTimeout(() => {
		$overlay.attr('aria-hidden', 'true');
	}, delay); //timeout should match transition value but can be passed in using CustomEvent detail
};

export default async function initItineraryOverlay() {
	const userStore = await getStore('userStore');
	const globalStore = await getStore('globalStore');

	const initOverlay = () => {
		const $overlay = $(`<div class='${baseClass}'></div>`);
		$overlay.addClass(classes.dialogBackground);
		$overlay.attr('role', 'dialog');
		$overlay.attr('tabIndex', -1);
		$overlay.attr('aria-modal', 'true');

		const $dialogOverlay = $(`<div class='${classes.dialogOverlay}'></div>`);
		$dialogOverlay.on('click', () => globalStore.clearUserPanelOpenTab());
		const $dialogWrapper = $(`<div class='${classes.dialogWrapper}'></div>`);
		$dialogWrapper.attr('role', 'document');

		$overlay.append($dialogOverlay);
		$overlay.append($dialogWrapper);

		return $overlay;
	};

	const onUserPanelOpen = () => {
		let $overlay = $(selectors.overlay);
		if ($overlay.length === 0) {
			//refresh globalstore if no active booking id
			if (globalStore && !globalStore.fetching && !globalStore.activeBookingId) {
				globalStore.refreshState();
			}

			//create the overlay and mount the userpanel if it doesn't already exist
			$overlay = initOverlay();
			$('body').append($overlay);

			//need to append the overlay before trying to mount the react component
			const tabs = window.FS?.globalInfo?.userPanelTabs || [];
			const $reactComp = $(
				`<div class="react-data UserPanel-placeholder UserPanel-react-ssr-placeholder tailwind-root" data-component-name="UserPanel" data-translations="true" data-locale="${$(
					'body'
				).data(
					'language'
				)}" ${tabs.length > 0 ? `data-tabs='${JSON.stringify(tabs)}'` : ''}></div>`
			);
			$reactComp.attr(
				'data-stores',
				JSON.stringify(['globalStore', 'cartStore', 'userStore'])
			);
			$overlay.find(selectors.dialogWrapper).append($reactComp);
			$reactComp.get(0).dispatchEvent(new Event('react.register', { bubbles: true }));
		}
		open($overlay);
	};

	const onUserPanelClose = () => {
		close($(selectors.overlay));
	};
	autorun(async () => {
		if (globalStore?.userPanelOpenTab) {
			onUserPanelOpen();
		} else if (!globalStore?.userPanelOpenTab) {
			onUserPanelClose();
		}
	});
}
